import React from 'react';
import { Link } from '@reach/router';


const NotFound = () => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh' }} >
    <img src='./img/not_found.svg' alt="404 Error, nothing here" width="320px" height="auto" />
    <div>
      <h2 style={{ margin: '1em' }} >Sorry, nothing here.</h2>
      <h3 style={{ margin: '1em' }} ><Link to='/'>Back to home</Link></h3>
    </div>
  </div>
)

export default NotFound;